import React from "react";
import snackImg1 from "./assets/6 pointers econirmit.png";

function Corevitus() {
  return (
    <div className="bg-white py-8 px-4 md:px-10">
      
      {/* Heading Section */}
      <div className="text-center mb-4 px-2">
        <h2 className="font-bold text-3xl sm:text-4xl md:text-5xl leading-tight">
          Core Virtues That Embody the Heart of Econirmit
        </h2>
      </div>

      {/* Subheading */}
      <div className="text-center mb-10 px-4">
        <span className="text-base sm:text-lg text-gray-600">
          This is why every product feels pure, purposeful, and divine
        </span>
      </div>

      {/* Image Section */}
      <div className="flex justify-center">
        <div className="w-full max-w-4xl px-4">
          <div className="flex flex-col items-center rounded-lg hover:shadow-md transition-all">
            <div className="w-full sm:w-[500px] h-auto">
              <img
                src={snackImg1}
                alt="Core Virtues"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Corevitus;
